












































import Vue from 'vue'
import Component from 'vue-class-component'
import NewMessage from '@/business/message/components/new-message.vue'
import { Prop } from 'vue-property-decorator'
import { Contact } from '@/business/message/models/contact'
import { Focusable } from '@/shared/interfaces/focusable'
import IncomingMessage from '@/business/message/components/incoming-message.vue'
import OutgoingMessage from '@/business/message/components/outgoing-message.vue'
import RespondecoBackgroundImage from '@/shared/components/respondeco-background-image.vue'

@Component({
  components: { RespondecoBackgroundImage, OutgoingMessage, IncomingMessage, NewMessage },
})
export default class ChatArea extends Vue implements Focusable {
  @Prop({
    type: Object,
    required: true,
  })
  public readonly contact!: Contact

  public beforeUpdate() {
    this.scrollToBottom()
  }

  public mounted() {
    this.scrollToBottom()
  }

  public focus() {
    const focusable: Focusable = (this.$refs.newMessage as unknown) as Focusable

    focusable.focus()
  }

  private scrollToBottom() {
    requestAnimationFrame(() => {
      const container: HTMLDivElement = this.$refs.messageContainer as any

      container.scrollTop = container.scrollHeight
    })
  }
}
